import {FaCheck} from "react-icons/fa";
import * as React from "react";
import {useState} from "react";
import {uniqueId} from "lodash";

const Checkbox = ({name, label, checked, onChange}) => {
  const [id] = useState(uniqueId('checkbox-'))
  return (
    <div className={"flex items-center"}>
      <input type="checkbox"
             id={id}
             name={name}
             checked={checked}
             className={"appearance-none p-0"}
             onChange={onChange}/>
      <label htmlFor={id} className="flex items-center gap-1 cursor-pointer">
        <div className={"bg-white border border-primary rounded-sm p-1"}>
          <span className="text-xs text-white">
            <FaCheck/>
          </span>
        </div>
        {label}
      </label>
    </div>
  )
}

export default Checkbox
